import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonService } from 'src/app/providers/common/common.service';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import * as _ from 'lodash';
import { LoadingController, Platform, AlertController } from '@ionic/angular';
import { AttachmentService } from 'src/app/providers/forms/attachment/attachment.service';
import { FormStatusMapping } from '../../headerSection/header/form-status-mapping';


@Component({
  selector: 'app-attachment-document-section',
  standalone: false,
  templateUrl: './attachment-document-section.component.html',
  styleUrls: ['./attachment-document-section.component.scss'],
})
export class AttachmentDocumentSectionComponent implements OnInit {

  @Input() formId;
  @Input() formTypeId;
  @Input() formStatus;
  @Input() attachments;
  @Input() keyCaptionMap;
  @Input() createdByuserId;
  @Output() attachementDocumentsEmmiter: EventEmitter<any> = new EventEmitter<any>();

  sectionOpen = false;
  files: File[] = [];
  isImageSelected = false;
  caption = "";
  loggedInUserId;
  collegeManagementId;
  collegeId;
  userId;
  attachmentsWithName = [];
  isMobileApp: boolean = false;
  notAllowedToAddAttchement: boolean = false;
  allowedUploadDocument: boolean = false;
  isFROMIQACDASHBOARD:boolean = false;
  exceedMaxLimit:boolean = false;
  profile:any = {};
  subscriptionStatus:boolean = true;
  constructor(
    private alertController: AlertController,
    private attachmentService: AttachmentService,
    private loadingController: LoadingController,
    private userdataService: UserDataService,
    public platform: Platform,
  ) { }

  ngOnInit() {
    this.getProfile()

    this.userdataService.getCurrentActiveSection().then(section =>{
      if(section){
        if(section === 'IQAC_DASHBORAD'){
          this.isFROMIQACDASHBOARD = true;
        }else {
          this.isFROMIQACDASHBOARD = false;
        }
      }
    })
    this.userdataService.getUserProfile().then(profile => {
      if (profile) {
        this.loggedInUserId = profile.id
        this.collegeId = profile.college.id;
        this.collegeManagementId = profile.college.managementCommittee.id;
        this.userId = profile.id;
        this.attachmentHandlingAllowed();
      }
    })
    if (this.formStatus == "SUBMITTED_FOR_APPROVAL") {
      this.notAllowedToAddAttchement = true;
    }
    if (this.platform.is('android')) {
      this.isMobileApp = true
    } else {
    }
    // this.userdataService.getUserProfile().then(profile => {
    //   if (profile) {
    //   }
    // });
    if (this.attachments === undefined) {
      this.attachments = [];
    }
    this.attachments.forEach((url, index) => {
      let attachmentWithUrl: any = {};
      attachmentWithUrl.url = url;
      attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(url);
      let key = this.deriveAttachmentKeyFromUrl(url);
      attachmentWithUrl.key = key;
      attachmentWithUrl.caption = this.keyCaptionMap[decodeURI(key)];
      this.attachmentsWithName.push(attachmentWithUrl);
    });
  }

  attachmentHandlingAllowed() {
    let status = this.formStatus;
    // if (this.attachmentsWithName.length >= 5) {
    //   // this.allowedUploadDocument = true;
    //  this.exceedMaxLimit= true;
    // }else {
    //   // this.allowedUploadDocument = false;
    //   this.exceedMaxLimit= false;
    //   return ;
    // }
    // if (this.allowedUploadDocument) {
      if (this.createdByuserId === this.loggedInUserId) {
        if ((status === "REVERTED" || status === "RESENT" || status === "CREATED"
          || status === "RECALLED")) {
            this.allowedUploadDocument = true;
        } else {
          this.allowedUploadDocument = false;
        }
      } else if (this.createdByuserId != this.loggedInUserId && status === 'REVERTED') {
        this.allowedUploadDocument = false;
      } else if (status === "SHARED" && this.createdByuserId != this.loggedInUserId) {
        this.allowedUploadDocument = true;
      } else if (status === "SUBMITTED_FOR_APPROVAL" || status === "APPROVED" || status === "APPROVED_WITH_WebC"
        || status === "APPROVED_WITH_OFFICE_CO" || status === "APPROVED_WITH_WEB_AND_OFFICE"
        || status === "APPROVED_WITH_WebC_UPDATED" || status === "APPROVED_WITH_OFFICE_CO_UPDATED"
        || status === "APPROVED_WITH_WEB_AND_OFFICE_UPDATED" || status === "APPROVED_WITH_BOTH_OFFICE_UPDATED"
        || status === "APPROVED_WITH_BOTH_WebC_UPDATED") {
          this.allowedUploadDocument = false;
      } else if (status === "SHARED_WITH_WebC" || status === "SHARED_WITH_OFFICE_CO" || status === "SHARED_WITH_WEB_AND_OFFICE") {
        this.allowedUploadDocument = false;
      // }
    }
    if (this.attachmentsWithName.length >= 4) {
      // this.allowedUploadDocument = true;
     this.exceedMaxLimit= true;
    }else {
      // this.allowedUploadDocument = false;
      this.exceedMaxLimit= false;
      return ;
    }

  }

  async onSelect(event) {
    CommonService.log(event)
    if (this.files.length > 0) {
      this.userdataService.presentToast("Only one Attachment file is supported to upload", "warning");
      return;
    } else {
      // Validate size
      /* if (event.addedFiles[0].size > 2000000) {
        this.userdataService.presentToast("Attachment size should not exceed 2MB", "warning");
        return;
      } */

      // Vaidate Type
      let type = event.addedFiles[0].type;
      // Word - application/vnd.openxmlformats-officedocument.wordprocessingml.document
      // Excel - application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      // PDF - application/pdf
      // JPG - image/jpeg
      // PNG - image/png

      /* if (_.includes(type, 'image/png') || _.includes(type, 'image/jpeg') || _.includes(type, 'image/jpg')) {
        this.files.push(...event.addedFiles);
      } else {
        this.userdataService.presentToast("Only png or jpeg images are allowed as Attachment", "warning");
        return;
      } */

      // Validate Extensions
      let name = _.lowerCase(event.addedFiles[0].name);
      if (_.endsWith(name, 'doc') || _.endsWith(name, 'docx') || _.endsWith(name, 'xls') || _.endsWith(name, 'xlsx') || _.endsWith(name, 'pdf')) {

        if (_.endsWith(name, 'png') || _.endsWith(name, 'jpg') || _.endsWith(name, 'jpeg')) {
          // Will never reach here.
          this.isImageSelected = true;
        } else {
          this.isImageSelected = false;
        }
        this.files.push(...event.addedFiles);
      } else {
        this.userdataService.presentToast("Only Word/Excel/PDF are allowed as Attachment", "warning");
        return;
      }
    }
  }

  onRemove(event) {
    CommonService.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  async uploadAttachment() {
    if(this.caption === undefined || this.caption === ""){
      this.userdataService.presentToast("Please add caption for attachment","warning");
      return false;
    }
    const loader = await this.loadingController.create({
      message: 'Uploading Attachment...'
    });
    loader.present();
    let payload: any = {}
    payload.managementCommitteeId = this.collegeManagementId
    payload.collageId = this.collegeId
    payload.userId = this.createdByuserId;
    payload.formTypeId = this.formTypeId;
    payload.formId = this.formId;
    payload.fileName = ""; // For upload it will taken from file name
    payload.caption = this.caption;
    const formData = new FormData();
    formData.append("file", this.files[0], this.files[0].name);

    this.attachmentService.upload(formData, payload, 'ATTACHMENT_DOCUMENT').subscribe(response => {
      if (response) {
        loader.dismiss();
        let urlToAttachment = response.attachmentSourceUrl;
        this.userdataService.presentToast("Attachment and Form Updated Successfully.", "success");
        // this.attachementDocumentsEmmiter.emit(urlToAttachment);
        if (this.attachments === undefined) {
          this.attachments = [];
        }
        this.attachments.push(urlToAttachment);
        this.attachementDocumentsEmmiter.emit(this.attachments);

        // FOR UI
        let attachmentWithUrl: any = {};
        attachmentWithUrl.url = urlToAttachment;
        attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(urlToAttachment);
        attachmentWithUrl.caption = this.caption;
        attachmentWithUrl.key=response.key;
        this.attachmentsWithName.push(attachmentWithUrl);
        this.attachmentHandlingAllowed();
        CommonService.log("Event - ",event);
        this.files.splice(this.files.indexOf(this.files[0]), 1);
        this.caption = "";
      } else {
        loader.dismiss();
      }
    }, error => {
      this.userdataService.presentToast("Attachment Addition Failed.", "danger");
      loader.dismiss();
    });
    return true;
  }

  deriveAttachmentNameFromUrl(url) {
    let untillFileName = url.substring(0, url.indexOf('?'));
    let fileName = untillFileName.substring(untillFileName.lastIndexOf('/') + 1);
    return fileName;
  }

  deriveAttachmentKeyFromUrl(url) {
    let key = url.substring(url.indexOf('.com') + 5, url.indexOf('?'));
    return key;
  }

  async confirmRemove(url) {

    const loader = await this.loadingController.create({
      message: 'Deleting Attachment...'
    });
    loader.present();
    let payload: any = {}
    payload.managementCommitteeId = this.collegeManagementId
    payload.collageId = this.collegeId
    payload.userId = this.createdByuserId;
    payload.formTypeId = this.formTypeId;
    payload.formId = this.formId
    payload.fileName = decodeURI(this.deriveAttachmentNameFromUrl(url));

    this.attachmentService.delete(payload, 'ATTACHMENT_DOCUMENT')
      .subscribe(response => {
        if (response) {
          this.attachments.forEach((link, index) => {
            if (url === link) {
              this.attachments.splice(index, 1);
              this.attachementDocumentsEmmiter.emit(this.attachments);
            }
          });
          this.attachmentsWithName.forEach((attachment, index) => {
            if (url === attachment.url) {
              this.attachmentsWithName.splice(index, 1);
            }
          });
          this.attachmentHandlingAllowed();
          this.userdataService.presentToast("Attachment Removed and Form Updated Successfully.", "success");
        }
        loader.dismiss();
      }, error => {
        this.userdataService.presentToast("Attachment Removal Failed.", "danger");
        loader.dismiss();
      });
  }

  async remove(url) {
    if (!this.attachmentHandlingAllowedDelete()) {
      this.userdataService.presentToast("You are not authorised to perform attachment remove operations!", "warning")
      return;
    }
    const alert = await this.alertController.create({
      header: "Remove Attachment",
      message: "Do you want to remove this attachment?",
      cssClass: 'custom-alert-theme',
      backdropDismiss: false,
      buttons: [{
        text: "Yes",
        role: "confirm",
        cssClass: 'alert-button-confirm',
        handler: () => {
          this.confirmRemove(url);
          return true;
        }
      },
      {
        text: "Cancel",
        role: "cancel",
        cssClass: 'alert-button-cancel',
        handler: () => {
          console.log("Cancelled delete operation");
          return true;
        }
      }
      ]
    });
    await alert.present();
  }

  isAttachmentImage(attachment: any) {
    let name = attachment.fileName;
    if (_.endsWith(name, 'png') || _.endsWith(name, 'jpg') || _.endsWith(name, 'jpeg')) {
      return true;
    }
    return false;
  }

  isPdf(attachment: any) {
    let name = attachment.fileName;
    if (_.endsWith(name, 'pdf')) {
      return true;
    }
    return false;
  }

  isWord(attachment: any) {
    let name = attachment.fileName;
    if (_.endsWith(name, 'doc') || _.endsWith(name, 'docx')) {
      return true;
    }
    return false;
  }

  isExcel(attachment: any) {
    let name = attachment.fileName;
    if (_.endsWith(name, 'xls') || _.endsWith(name, 'xlsx')) {
      return true;
    }
    return false;
  }

  download(attachment: any) {
    const link = document.createElement('a');
    link.href = attachment.url;
    link.setAttribute('download', attachment.fileName);
    link.setAttribute('target', '_blank');

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
  attachmentHandlingAllowedDelete() {
    let status = this.formStatus;
    let allowed = false;
       if (this.createdByuserId === this.loggedInUserId) {
         if ((status === "REVERTED" || status === "RESENT" || status === "CREATED"
           || status === "RECALLED")) {
           allowed = true;
         } else {
           allowed = false;
         }
       } else if (this.createdByuserId != this.loggedInUserId && status === 'REVERTED') {
         allowed = false;
       }  else if (status === "SUBMITTED_FOR_APPROVAL" || status === "APPROVED" || status === "APPROVED_WITH_WebC"
         || status === "APPROVED_WITH_OFFICE_CO" || status === "APPROVED_WITH_WEB_AND_OFFICE"
         || status === "APPROVED_WITH_WebC_UPDATED" || status === "APPROVED_WITH_OFFICE_CO_UPDATED"
         || status === "APPROVED_WITH_WEB_AND_OFFICE_UPDATED" || status === "APPROVED_WITH_BOTH_OFFICE_UPDATED"
         || status === "APPROVED_WITH_BOTH_WebC_UPDATED") {
         allowed = false;
       } else if (status === "SHARED_WITH_WebC" || status === "SHARED_WITH_OFFICE_CO" || status === "SHARED_WITH_WEB_AND_OFFICE") {
         allowed = false;
       }else if (status === "SHARED" && this.createdByuserId === this.loggedInUserId) {
         allowed = false;
       }else if(status === "SHARED" && this.createdByuserId != this.loggedInUserId){
         allowed = true;
       }
     return allowed;
   }

   async editCaption(key, caption, attachment) {
    if (!this.attachmentHandlingAllowedDelete()) {
      this.userdataService.presentToast("You are not authorised to perform caption edit!", "warning")
      return false;
    }
    const alert = await this.alertController.create({
      header: "Edit Caption",
      message: "Please type image caption below",
      inputs: [{
        name: "caption",
        type: "textarea",
        value:caption
      }],
      buttons: [{
        text: "Save",
        role: "Ok",
        handler: (data) => {
          this.confirmEditCaption(key, data.caption);
          attachment.caption = data.caption;
        }
      },
      {
        text: "Cancel",
        role: "cancel",
        handler: () => {
          console.log("Cancel");
        }
      }
      ]
    })
    alert.present();
    return true;
  }

  async confirmEditCaption(key, captionText) {

    const loader = await this.loadingController.create({
      message: 'Saving image caption'
    });
    loader.present();
    let payload: any = {}
    payload.key = key;
    payload.caption = captionText
    this.attachmentService.editCaption(payload)
      .subscribe(response => {
        if (response) {
          
        }
        loader.dismiss();
      }, error => {
        this.userdataService.presentToast("Caption edit failed.", "danger");
        loader.dismiss();
      });
  }

  getProfile()
    {
      this.userdataService.getUserProfile().then((profile) => {
        if (profile) {
          this.profile = profile;
          if(this.profile.college.status == "SUBS_EXPIRED")
          {
            this.subscriptionStatus = false;
          }
        }
      });
    }
}
